import React from "react";
import styled from "styled-components";
import assets from "../../../assets/assets";
import ArtistImage from "./ArtistImage";
import SidebarMenu from "./SidebarMenu";
import { IconController, ImgController } from "../../Scripts/ImgController";
import BackgroundImage from "../../../assets/images/sidebar-bg.png";
import ToggleSidebarMenu from "./SidebarMenuSwitch";
const Wrapper = styled.div`
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 101 !important;
  background-image: url(${BackgroundImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

const KaraokeSidebar = ({
  sidebarExpanded,
  setSidebarExpanded,
  currentPublisher,
  setLogoutConfirmation,
  drawer = false, // mobile дээр ☰ drawer болж харагдана
  drawerOpen = false,
}) => {
  // drawer үед үргэлж дэлгэрэнгүй харагдана
  const expanded = drawer || sidebarExpanded;
  const accessData = JSON.parse(localStorage.getItem("Current-Access"));
  return (
    <Wrapper
      className={`${
        expanded ? "w-sidebar-expanded" : "w-sidebar-collapsed"
      } duration-300 ${
        drawer ? (drawerOpen ? "translate-x-0" : "-translate-x-full") : ""
      }`}
    >
      {/* Carickao: end Ripples hiiheer muuhai haragdaad bsn bolhoor ni avaad haychihsooooon */}
      {!drawer && (
        <div
          className="absolute cursor-pointer -right-4 top-7 rounded-full"
          onClick={() => {
            setSidebarExpanded(!sidebarExpanded);
          }}
        >
          <IconController
            src={assets.svg.sidebarArrow}
            alt=""
            className={`bg-white p-1 rounded-full border-4 border-sidebar ${
              !sidebarExpanded ? "rotate-180" : ""
            }`}
          />
        </div>
      )}

      <div className={`flex flex-col h-full ${drawer ? "overflow-y-auto" : ""}`}>
        <div className={`flex flex-row justify-center items-center px-8 pt-8 ${drawer ? "pb-10" : "pb-20"}`}>
          <a href="/" className="cursor-pointer">
            <div className="flex  gap-1 h-10">
              <IconController />
              {/*<img src={assets.svg.mmusicLogoWhiteSmall} alt="" />*/}
              <ImgController
                src={assets.svg.mkaraokeLogoWhiteText}
                alt=""
                className={`h-full duration-300 ${
                  !expanded ? "scale-0" : ""
                }`}
              />
              {/* {!sidebarExpanded ? "" : } */}
            </div>
          </a>
        </div>
        <ArtistImage sidebarExpanded={expanded} />
        <div className="flex flex-col flex-1 gap-5">
          <SidebarMenu
            type="mkaraoke"
            icon={assets.svg.sidebarWallet}
            title="Хэтэвч"
            where=""
            sidebarExpanded={expanded}
            setLogoutConfirmation={setLogoutConfirmation}
          />
          <SidebarMenu
            type="mkaraoke"
            icon={assets.svg.sidebarStatistic}
            title="Статистик"
            where="statistic"
            sidebarExpanded={expanded}
            setLogoutConfirmation={setLogoutConfirmation}
          />
          <SidebarMenu
            type="mkaraoke"
            icon={assets.svg.sidebarNote}
            title="Уран бүтээл"
            where="creation"
            sidebarExpanded={expanded}
            setLogoutConfirmation={setLogoutConfirmation}
          />
          <SidebarMenu
            type="mkaraoke"
            icon={assets.svg.sidebarProfile}
            title="Профайл"
            where="profile"
            sidebarExpanded={expanded}
            setLogoutConfirmation={setLogoutConfirmation}
          />
        </div>
        <div className="pb-4">
          {accessData?.is_karaoke_active === true ? (
            <div className="pb-6">
              <ToggleSidebarMenu
                type="mkaraoke"
                icon={assets.svg.shuffle}
                title="Mmusic самбар"
                sidebarExpanded={expanded}
                setLogoutConfirmation={setLogoutConfirmation}
              />
            </div>
          ) : (
            ""
          )}

          <SidebarMenu
            type="mkaraoke"
            icon={assets.svg.sidebarLogout}
            title="Гарах"
            where="logout"
            sidebarExpanded={expanded}
            setLogoutConfirmation={setLogoutConfirmation}
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default KaraokeSidebar;
